import { COUNTRIES } from './countries';
import { Country } from '../../types';

export const MS_PER_DAY = 86400000;
export * from './countries';

export const countriesMapByCountryCodes: Record<string, Country> = {};
for (let i = 0; i < COUNTRIES.length; i++) {
  countriesMapByCountryCodes[COUNTRIES[i].abbr] = COUNTRIES[i];
}

export const countriesMapByCountryName: Record<string, Country> = {};
for (let i = 0; i < COUNTRIES.length; i++) {
  countriesMapByCountryName[COUNTRIES[i].name] = COUNTRIES[i];
}

export const countryCodes = COUNTRIES.map(({abbr}) => abbr);

export const DEFAULT_PAGE_SIZE = 10;
export const MAX_DISPLAY_PAGES_MOBILE = 3;

export const MS_PER_MIN = 60000;
